'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Heading } from '../heading/heading.js';

/**
 * DropdownHeading component, used to display a heading in the Dropdown.
 *
 * @example
 * <Dropdown>
 *  <DropdownHeading>Heading</DropdownHeading>
 * </Dropdown>
 */
const DropdownHeading = forwardRef(function DropdownHeading(rest, ref) {
    return jsx(Heading, { ref: ref, ...rest });
});

export { DropdownHeading };
